import {
    AfterContentInit, ChangeDetectorRef, ContentChildren, Directive, ElementRef, Input, OnChanges,
    OnDestroy, QueryList, Renderer, SimpleChanges
} from '@angular/core';

import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from 'rxjs/Subscription';

import { RouterNamedLink, RouterNamedLinkWithHref } from "./router-named-link";


@Directive({
    selector: '[routeActive]',
    exportAs: 'routeActive',
})
export class RouterNamedLinkActive implements OnChanges, OnDestroy, AfterContentInit {

    @ContentChildren(RouterNamedLink, {descendants: true}) links: QueryList<RouterNamedLink>;
    @ContentChildren(RouterNamedLinkWithHref, {descendants: true}) linksWithHrefs: QueryList<RouterNamedLinkWithHref>;

    private classes: string[] = [];
    private subscription: Subscription;
    private active: boolean   = false;

    private activeIfRoute;

    @Input() routeActiveOptions: { exact: boolean } = {exact: false};

    constructor(private router: Router, private element: ElementRef, private renderer: Renderer,
                private cdr: ChangeDetectorRef) {

        this.subscription = router.events.subscribe(s => {
            if (s instanceof NavigationEnd) {
                this.update();
            }
        });

    }

    get isActive(): boolean {

        return this.active;

    }

    ngAfterContentInit(): void {

        this.links.changes.subscribe(_ => this.update());
        this.linksWithHrefs.changes.subscribe(_ => this.update());
        this.update();

    }

    @Input()
    set activeIf(data: string) {

        this.activeIfRoute = data;

    }

    @Input()
    set routeActive(data: string[] | string) {

        const classes = Array.isArray(data) ? data : data.split(' ');

        this.classes  = classes.filter(c => !!c);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private update(): void {

        if (!this.links || !this.linksWithHrefs || !this.router.navigated) return;
        const hasActiveLinks = this.hasActiveLinks();

        // react only when status has changed to prevent unnecessary dom updates
        if (this.active !== hasActiveLinks) {
            this.active = hasActiveLinks;
            this.classes.forEach(
                c => this.renderer.setElementClass(this.element.nativeElement, c, hasActiveLinks));
            this.cdr.detectChanges();
        }

    }

    private isLinkActive(router: Router): (link: (RouterNamedLink | RouterNamedLinkWithHref)) => boolean {

        return (link: RouterNamedLink | RouterNamedLinkWithHref) =>
            router.isActive(link.urlTree, this.routeActiveOptions.exact);

    }

    private hasActiveLinks(): boolean {

        return this.links.some(this.isLinkActive(this.router)) ||
            this.linksWithHrefs.some(this.isLinkActive(this.router));

    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/routing/directives/router-named-link-active.ts